import React from 'react';
import {
  Typography,
  Container
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { proDesignTokens } from '../common/ProDesignTokens';
import MembershipPricingCards from './MembershipPricingCards';

export default function SubscriptionRequired() {
  const location = useLocation();
  
  // Get context about why user was redirected here
  const fromLocation = location.state?.from;

  // Removed secondary Sign In CTA per request

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 600,
          color: proDesignTokens.colors.neutral[900],
          mb: 3,
          textAlign: 'center'
        }}
      >
        Start Your myStack Membership
      </Typography>
      <MembershipPricingCards
        source="subscription_required_page"
        description="Choose a plan to start your 14-day free trial."
        previousLocation={fromLocation?.pathname}
      />
    </Container>
  );
} 